import React from 'react';
import './Cards.css';
import CardItem from './CardItem'

function Cards() {
  return (
    <div className='cards'>
      <h1>Estos son algunos de nuestros projectos</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/p001001.jpg'
              text='Reparacion rodillo compactardor'
              label='Maquinaria Pesada'
              path='/projects/001'
            />
            <CardItem
              src='images/project0051.jpeg'
              text='Reparacion brazo hidraulico'
              label='Maquinaria Pesada'
              path='/projects/005'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/project0041.jpeg'
              text='Reparacion transmision de excavadora'
              label='Maquinaria Pesada'
              path='/projects/004'
            />
            
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;